import { Table } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { priceEstimateSummaryStyle } from '../../utils/layoutConst'
import { useDeclension } from '../../utils/useDeclension'

export interface SubjectSearchResultTableSummaryProps {
  totalCount: number
}

export const SubjectSearchResultTableSummary: FunctionComponent<SubjectSearchResultTableSummaryProps> =
  memo(({ totalCount }) => {
    const decline = useDeclension()

    return (
      <Table.Summary>
        <Table.Summary.Row>
          <Table.Summary.Cell
            index={0}
            colSpan={6}
            className={'!p-0 ' + priceEstimateSummaryStyle}
          >
            {totalCount === 1000 ? (
              <div className="flex w-full text-center p-2 text-amber-600 justify-center">
                Dosažen max. limit 1000 záznamů. Upřesněte prosím adresu pro
                zúžení výsledků vyhledávání.
              </div>
            ) : (
              <div className="flex text-gray-400 p-2">
                Celkem: {decline(totalCount, 'record', true)}
              </div>
            )}
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </Table.Summary>
    )
  })
